export enum ELevel {
  Level1Count = 'level1Count',
  Level2Count = 'level2Count',
  Level3Count = 'level3Count',
  Level4Count = 'level4Count'
}
